import React from "react";
import { InboxIcon } from "./icons";

/** Designed empty state (§3.14): icon + one sentence + primary action. */
function EmptyState({ icon, title, message, action }) {
  return (
    <div className="fk-empty">
      <span className="fk-empty__icon">{icon || <InboxIcon size={32} />}</span>
      {title ? <h3 className="fk-empty__title">{title}</h3> : null}
      {message ? <p className="fk-empty__message">{message}</p> : null}
      {action}
    </div>
  );
}

export default EmptyState;
